import React from 'react';
import ReviewBadge, { useReviews, LOCALE } from './ReviewBadge';

// Úvodní obrazovka (1. krok rychlého nastavení): odznak hodnocení a vybrané recenze zákazníků.
// Recenze vybírá administrace (Administrace → Recenze) podle jazyka; texty jsou doslovně ze zdroje, proto se nepřekládají.
const HEAD: Record<string, string> = { cs: 'Co říkají zákazníci', sk: 'Čo hovoria zákazníci', pl: 'Co mówią klienci', de: 'Das sagen unsere Kunden', it: 'Cosa dicono i clienti', es: 'Lo que dicen los clientes', hu: 'Vásárlóink mondták', en: 'What customers say' };
const ANON: Record<string, string> = { cs: 'Zákazník', sk: 'Zákazník', pl: 'Klient', de: 'Kunde', it: 'Cliente', es: 'Cliente', hu: 'Vásárló', en: 'Customer' };
const MORE: Record<string, string> = { cs: 'Všechny recenze', sk: 'Všetky recenzie', pl: 'Wszystkie opinie', de: 'Alle Bewertungen', it: 'Tutte le recensioni', es: 'Todas las reseñas', hu: 'Összes értékelés', en: 'All reviews' };

const ReviewsIntro: React.FC<{ variant?: 'wizard' | 'page' }> = ({ variant = 'wizard' }) => {
  const [r, lang] = useReviews();
  if (!r || r.source === 'off' || !r.url) return null;
  const quotes = (r.quotes || []).slice(0, 3);
  const loc = LOCALE[lang] || 'cs-CZ';
  const fmt = (d: string) => { try { return new Date(`${d}T12:00:00`).toLocaleDateString(loc, { day: 'numeric', month: 'numeric', year: 'numeric' }); } catch { return d; } };
  return (
    <section className={`rdw-reviews${variant === 'page' ? ' rdw-reviews--page no-print' : ''}`} aria-label={HEAD[lang] || HEAD.en} translate="no" data-reviews-intro={variant}>
      <div className="rdw-reviews-head">
        <h2>{HEAD[lang] || HEAD.en}</h2>
        <ReviewBadge large />
      </div>
      {quotes.length > 0 && (
        <ul className="rdw-reviews-list">
          {quotes.map((q, i) => (
            <li key={i}>
              <blockquote>„{q.text}“</blockquote>
              <p className="rdw-reviews-meta">
                {typeof q.score === 'number' && q.score > 0 && <span className="rdw-reviews-stars" aria-hidden="true">{'★'.repeat(Math.max(1, Math.round(q.score / 20)))}</span>}
                <span>{q.author || ANON[lang] || ANON.en}{q.date ? ` · ${fmt(q.date)}` : ''}{q.source === 'google' ? ' · Google' : /heureka\.sk/i.test(q.url) ? ' · Heureka.sk' : ' · Heureka.cz'}</span>
              </p>
            </li>
          ))}
        </ul>
      )}
      {quotes.length > 0 && <a className="rdw-reviews-more" href={r.url} target="_blank" rel="noopener noreferrer">{MORE[lang] || MORE.en} →</a>}
    </section>
  );
};

export default ReviewsIntro;
